// Get the API URL from environment variables
// Last deployment attempt: 2024-03-21
const API_URL = import.meta.env.VITE_API_URL;
const IS_PROD = import.meta.env.PROD || window.location.hostname === 'moodshelf.vercel.app' || window.location.hostname === 'moodshelf.io';
const IS_DEV = !IS_PROD;
const PROD_API_URL = 'https://api.moodshelf.io';

// Default fetch options for all API calls
export const defaultFetchOptions = {
  credentials: 'include',
  headers: {
    'Content-Type': 'application/json'
  }
};

// Export the base URL
export const API_BASE_URL = (() => {
  // Always use PROD_API_URL if we're on production domains
  return IS_PROD ? PROD_API_URL : (API_URL || 'http://localhost:3000');
})(); 